module.exports = __webpack_public_path__ + "media/images/countrysquared/tm-140742753d16c8ad5749fde011932407.svg";